const APP_DEEPLINK_SCHEME = 'paceplus://';
const FALLBACK_DELAY = 1200;
const SAFE_URL_SCHEMES = ['http:', 'https:'];

export type PaceAppTarget = {
  deeplink?: string;
  fallbackUrl?: string;
};

function safeFallbackUrl(url: string): string {
  try {
    return SAFE_URL_SCHEMES.includes(new URL(url, window.location.origin).protocol) ? url : '';
  } catch {
    return '';
  }
}

export function openPaceApp({ deeplink = '', fallbackUrl = '' }: PaceAppTarget): void {
  if (deeplink.indexOf(APP_DEEPLINK_SCHEME) !== 0) {
    return;
  }

  const fallback = fallbackUrl ? safeFallbackUrl(fallbackUrl) : '';

  if (!fallback) {
    window.location.href = deeplink;
    return;
  }

  const cancel = () => {
    if (!document.hidden) {
      return;
    }

    window.clearTimeout(timer);
    document.removeEventListener('visibilitychange', cancel);
  };

  const timer = window.setTimeout(() => {
    document.removeEventListener('visibilitychange', cancel);
    window.location.href = fallback;
  }, FALLBACK_DELAY);

  document.addEventListener('visibilitychange', cancel);
  window.location.href = deeplink;
}
